module.exports = __webpack_public_path__ + "resources/search-61b1c747aa872b5ab4aa8c43b0dec52b.svg";